<template>
  <div class="verification-segment" v-if="taskName">
    <v-icon small color="bg_force_white" class="segment-icon">mdi-shield-check-outline</v-icon>
    <span class="segment-text">
      <span class="segment-label">Verification</span>
      <span class="segment-sep">·</span>
      <span class="segment-task-name text-truncate" :title="taskName">{{ taskName }}</span>
    </span>
  </div>
</template>

<script>
/**
 * Breadcrumb segment shown only on the verification-workspace route.
 *
 * Reads `taskName` from the VERIFICATION Vuex module (populated when
 * LOAD_VERIFICATION resolves). If the task name hasn't loaded yet (cold deep
 * link), renders nothing so the breadcrumb doesn't flicker.
 *
 * Rendered conditionally by TopBarBreadcrumb — this component does not
 * check the route itself.
 */
import { mapGetters } from 'vuex';

export default {
  name: 'VerificationSegment',
  computed: {
    ...mapGetters('VERIFICATION', {
      taskName: 'GET_TASK_NAME',
    }),
  },
};
</script>

<style lang="scss" scoped>
.verification-segment {
  display: inline-flex;
  align-items: center;
  max-width: 360px;
}

.segment-icon {
  margin-right: 8px;
}

.segment-text {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--v-bg_force_white-base);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01em;
  height: 20px;
  user-select: none;
  min-width: 0;
}

.segment-label {
  font-weight: 500;
  white-space: nowrap;
}

.segment-sep {
  opacity: 0.55;
}

.segment-task-name {
  max-width: 240px;
  font-weight: 400;
  display: inline-block;
  vertical-align: middle;
}

@media (max-width: 900px) {
  .segment-task-name {
    max-width: 140px;
  }
}
</style>
